import AxiosInstance from "../instance";


const getSummarizerReport = async (ticker: string, exchange: string) => {
    const response = await AxiosInstance.getInstance().get("/summarizer", {
        params: {
            exchange_ticker: exchange + "-" + ticker
        },
        responseType: "blob"
    });
    return response;
};

export {getSummarizerReport};


// WEBPACK FOOTER //
// ./src/api/models/Summarizer.ts